<template>
  <v-container fluid class="pt-0">
    <v-row class="pt-0">
      <v-dialog v-model="dialog" max-width="500">
        <v-card>
          <v-card-title class="text-h5">{{
            $t('title_form_reg_emp')
          }}</v-card-title>
          <v-card-title class="subtitle-1">{{
            $t('title_form_reg_emp_sub')
          }}</v-card-title>

          <v-card-text>
            <v-form ref="createEmployee">
              <v-row>
                <v-col cols="6">
                  <v-row>
                    <v-col cols="12" sm="12">
                      <v-text-field
                        v-model="newEmp.empName"
                        :rules="nameRule"
                        :hint="$t('cap_form_reg_emp_name')"
                        persistent-hint
                        outlined
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12">
                      <v-text-field
                        v-model="newEmp.phoneNumber"
                        :rules="numRule"
                        :hint="$t('cap_from_reg_emp_phone')"
                        persistent-hint
                        outlined
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12">
                      <!--                      <v-select-->
                      <!--                        v-model="newEmp.branch"-->
                      <!--                        :items="branches"-->
                      <!--                        :placeholder="$t('btn_cap_all_branches')"-->
                      <!--                      ></v-select>-->
                      <v-autocomplete
                        v-model="newEmp.branch"
                        :rules="required"
                        :items="$store.getters['tenant/branches']"
                        filled
                        chips
                        :hint="$t('btn_cap_branches')"
                        multiple
                        outlined
                        persistent-hint
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            v-bind="data.attrs"
                            :input-value="data.selected"
                            close
                            @click="data.select"
                            @click:close="onRemoveBranch(data.item)"
                          >
                            {{ data.item }}
                          </v-chip>
                        </template>
                        <template v-slot:item="data">
                          <template v-if="typeof data.item !== 'object'">
                            <v-list-item-content
                              v-text="data.item"
                            ></v-list-item-content>
                          </template>
                          <template v-else>
                            <v-list-item-content>
                              <v-list-item-title
                                v-html="data.item"
                              ></v-list-item-title>
                              <v-list-item-subtitle
                                v-html="data.item.active"
                              ></v-list-item-subtitle>
                            </v-list-item-content>
                          </template>
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="6">
                  <span>{{ $t('cap_form_position') }}</span>
                  <v-radio-group v-model="newEmp.role" column :rules="required">
                    <v-radio label="Admin" value="admin"></v-radio>
                    <v-radio label="Sale Person" value="sale"></v-radio>
                  </v-radio-group>
                  <!--                <v-btn class="primary">{{$t('btn_cap_add_profile')}}</v-btn>-->
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-btn color="primary" text @click="onCancel">
              {{ $t('btn_txt_cancel') }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="onSubmit">
              {{ $t('btn_cap_save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-col cols="12">
        <v-row>
          <v-col cols="12" sm="5">
            <div class="primary--text text-h6 text-md-h5 font-weight-medium">
              {{ $t('title_cap_employee') }}
            </div>
          </v-col>
        </v-row>
        <v-row justify="space-between" align="center" class="pt-0">
          <v-col cols="12" sm="3" class="pt-0">
            <v-btn outlined color="primary" @click.stop="dialog = true">{{
              $t('btn_cap_reg_new_employee')
            }}</v-btn>
          </v-col>
          <v-col cols="12" sm="3" class="pt-0">
            <v-select
              v-model="filterBranch"
              :items="filBranches"
              placeholder="All Branches"
            ></v-select>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="8">
        <v-row>
          <v-col cols="12" md="12">
            <v-card>
              <v-card-title>
                <span class="headline primary--text font-weight-regular">
                  {{ $t('title_cap_admin') }}
                </span>
                <v-spacer></v-spacer>
                <span class="subtitle-2 font-weight-regular">
                  {{
                    $t('cap_admin_count', {
                      value:
                        $store.getters['employee/employeeAdminOrOwner'].length
                    })
                  }}
                </span>
              </v-card-title>
              <v-card-subtitle>
                <v-list-item class="pl-0">
                  <v-list-item-icon>
                    <v-icon class="primary--text"
                      >mdi-information-variant</v-icon
                    >
                  </v-list-item-icon>
                  <v-list-item-subtitle>
                    {{ $t('title_cap_admin_policy') }}
                  </v-list-item-subtitle>
                </v-list-item>
              </v-card-subtitle>

              <v-container class="pt-0">
                <v-row dense>
                  <v-col cols="12">
                    <v-card
                      v-for="admin in $store.getters[
                        'employee/employeeAdminOrOwner'
                      ]"
                      :key="admin.documentId"
                      class="mx-auto"
                      flat
                    >
                      <v-card-text class="py-0">
                        <span class="d-flex pa-3">
                          <v-avatar size="70" class="mr-3" color="primary">
                            <span class="white--text headline">
                              {{ admin.name.charAt(0) }}
                            </span>
                          </v-avatar>
                          <span class="primary--text align-self-center">
                            <div class="font-weight-bold">{{ admin.name }}</div>
                            <div>{{ admin.phone }}</div>
                            <div>
                              {{ formatBranch(admin.branchId) || 'company' }}
                            </div>
                          </span>
                        </span>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>

          <v-col cols="12" md="12">
            <v-card>
              <v-card-title>
                <span class="headline primary--text font-weight-regular">
                  {{ $t('title_sale_admin') }}
                </span>
                <v-spacer></v-spacer>
                <span class="subtitle-2 font-weight-regular">
                  {{
                    $t('cap_sale_count', {
                      value: $store.getters['employee/employeeSales'].length
                    })
                  }}
                </span>
              </v-card-title>
              <v-card-subtitle class="pb-0">
                <v-list-item class="pl-0">
                  <v-list-item-icon>
                    <v-icon class="primary--text"
                      >mdi-information-variant</v-icon
                    >
                  </v-list-item-icon>
                  <v-list-item-subtitle>
                    {{ $t('title_cap_sale_policy') }}
                  </v-list-item-subtitle>
                </v-list-item>
              </v-card-subtitle>
              <!--              <v-card-text class="primary&#45;&#45;text">-->
              <!--                Aeon 1-->
              <!--              </v-card-text>-->
              <v-container class="pt-0">
                <v-row dense>
                  <v-col cols="12">
                    <v-card
                      v-for="sale in $store.getters['employee/employeeSales']"
                      :key="sale.documentId"
                      class="mx-auto"
                      flat
                    >
                      <v-card-text class="py-0">
                        <span class="d-flex pa-3">
                          <v-avatar size="70" class="mr-3" color="primary">
                            <span class="white--text headline">
                              {{ sale.name.charAt(0) }}
                            </span>
                          </v-avatar>
                          <span class="primary--text align-self-center">
                            <div class="font-weight-bold">{{ sale.name }}</div>
                            <div>{{ sale.phone }}</div>
                            <div>{{ sale.branchId || 'company' }}</div>
                          </span>
                        </span>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="4">
        <v-row>
          <v-col cols="12">
            <v-card class="mx-auto">
              <v-card-title class="primary--text">
                {{ $t('title_owner') }}
              </v-card-title>
              <v-card-text>
                <span class="d-flex pa-3">
                  <v-avatar size="70" class="mr-3" color="primary">
                    <span class="white--text headline">
                      {{ name.charAt(0) }}
                    </span>
                  </v-avatar>
                  <span class="primary--text align-self-center">
                    <div class="font-weight-bold">{{ name }}</div>
                    <div>{{ phone }}</div>
                  </span>
                </span>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12">
            <v-card class="mx-auto">
              <v-card-text class="pb-0">
                <v-avatar size="34"
                  ><img
                    src="https://img.icons8.com/color/48/000000/facebook-messenger.png"
                    alt="facebookIcon"
                /></v-avatar>
                <span>
                  {{ $store.state.tenant.name }}
                </span>
              </v-card-text>
              <v-card-text class="pb-0 pt-3">
                <v-icon>mdi-domain</v-icon>
                <span class="pl-1">
                  {{ $store.getters['tenant/branches'].join(', ') }}
                </span>
              </v-card-text>
              <!--          <v-card-text class="pb-0">-->
              <!--            <v-icon>mdi-table</v-icon>-->
              <!--            <span class="pl-1">Promotions Sets</span>-->
              <!--          </v-card-text>-->
              <v-card-text class="pb-0">
                <v-icon>mdi-map-marker</v-icon>
                <span class="pl-1">
                  {{ $store.state.tenant.registeredLocation.address }}
                </span>
              </v-card-text>
              <v-card-text>
                <v-icon>mdi-account-multiple</v-icon>
                <span class="pl-1">
                  {{
                    $t('cap_emp_count', {
                      value: $store.getters['employee/countEmployees']
                    })
                  }}
                </span>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-snackbar
        v-model="snackbar"
        :right="true"
        :bottom="true"
        :multi-line="true"
      >
        {{ message }}
        <template v-slot:action="{ attrs }">
          <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>

      <v-overlay
        :value="
          $store.getters['tenant/activeBranches'].length <= 0
            ? (overlay = true)
            : (overlay = false)
        "
        :opacity="opacity"
      >
        <router-link to="/setting"
          ><h4>{{ $t('cap_required_setup') }}</h4></router-link
        >
      </v-overlay>
    </v-row>
  </v-container>
</template>

<script>
import PhoneNumber from 'awesome-phonenumber'

export default {
  data: () => ({
    items: ['B1', 'B2', 'All'],
    value: 'All',
    filterBranch: '',
    snackbar: false,
    message: '',
    newEmp: {
      empName: '',
      phoneNumber: '',
      branch: '',
      role: null
    },
    dialog: false,
    overlay: false,
    opacity: 1
  }),
  computed: {
    name() {
      return this.$store.state.account.profile.name
    },
    phone() {
      return this.$store.state.account.profile.phone
    },
    filBranches() {
      const branch = JSON.parse(
        JSON.stringify(this.$store.getters['tenant/branches'])
      )
      branch.unshift('All')
      return branch
    },
    branches() {
      return this.$store.getters['tenant/activeBranches'].map((x) => x.name)
    },
    nameRule() {
      return [
        (v) => !!v || this.$t('cap_msg_setting_form_err_001'),
        (v) =>
          /^[a-zA-Z0-9]{1,}(?: [a-zA-Z0-9]+){0,2}$/gi.test(v) ||
          this.$t('cap_msg_setting_form_err_002')
      ]
    },
    numRule() {
      return [
        (v) => !!v || this.$t('cap_msg_setting_form_err_003'),
        (v) =>
          /^(((\+855)|(0))\d{8,10})$/gi.test(v) ||
          this.$t('cap_msg_setting_form_err_004')
      ]
    },
    required() {
      return [(v) => !!v || this.$t('cap_msg_required')]
    }
  },
  watch: {
    filterBranch(v) {
      if (v === 'All') {
        v = ''
      }
      this.$store.commit('employee/filterBranch', v)
    }
  },
  methods: {
    onCancel() {
      this.dialog = false
      this.newEmp = {
        empName: '',
        phoneNumber: '',
        branch: '',
        role: null
      }
    },
    onSubmit() {
      if (this.$refs.createEmployee.validate()) {
        let pn
        if (
          this.newEmp.phoneNumber.startsWith('+') ||
          !this.newEmp.phoneNumber.startsWith('0')
        ) {
          // this must be e164 format (i.e. prefixed with a +)
          this.newEmp.phoneNumber = !this.newEmp.phoneNumber.startsWith('+')
            ? `+${this.newEmp.phoneNumber}`
            : this.newEmp.phoneNumber
          pn = new PhoneNumber(this.newEmp.phoneNumber)
        } else {
          // let use cambodia format here
          pn = new PhoneNumber(this.newEmp.phoneNumber, 'KH')
        }
        this.newEmp.phoneNumber = pn.getNumber('e164')
        this.$store
          .dispatch('employee/createEmployee', this.newEmp)
          .then((data) => {
            const body = data.data
            this.snackbar = body.success
            this.message = body.result
          })
          .catch(() => {
            this.snackbar = true
            this.message = 'Employee cannot be created'
          })
        this.onCancel()
      }
    },
    onRemoveBranch(item) {
      const index = this.newEmp.branch.indexOf(item)
      if (index >= 0) {
        this.newEmp.branch.splice(index, 1)
      }
    },
    formatBranch(branch) {
      if (typeof branch === 'string') {
        return branch
      } else {
        return branch.join(', ')
      }
    }
  }
}
</script>
